import React from 'react';
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom';
import LoadingMessages from '../../components/LoadingMessages';

const Users = () => {
    const {
        isLoading,
        hasLoadingError,
        loadingErrorMessage
    } = useSelector(state => state.users);

    return (
        <div className="Users">
            <LoadingMessages
                isLoading={ !!isLoading }
                hasError={ !!hasLoadingError }
                errorMessage={ loadingErrorMessage }
            />

            <Outlet />

        </div>
    );
}


export default Users;
